module.exports = __webpack_public_path__ + "static/media/gradeAverage.68a73603.svg";